import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsArticlesViewArticleRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-articles-view-article',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles/:articleId',
	exact: true,
};
